export default __webpack_public_path__ + "static/media/signup.fa5b19af.jpg";